const API_URL =
  process.env.NODE_ENV === 'production'
    ? 'https://api-beta.bctools.io'
    : 'https://api.bctools.local'

const fetchCfg = () => ({
  method: 'get',
  mode: 'cors',
  credentials: 'include',
  headers: {
    'Content-Type': 'application/json',
  },
})

export { API_URL, fetchCfg }
